import { getSingleAlertName } from '@/app/common/converters/alert/singleAlertTypeToTextConverter'
import { SingleAlertType } from '@/app/constants/singleAlertType'
import {
  FieldsetSelect,
  Option,
} from '@/modules/settings/components/FieldsetSelect'
import { useLocalize } from '@/modules/shared/context/localize/LocalizeContext'
import React from 'react'
import { useAlertForm } from '../AlertFormContext'
import { FaIcon, faTruckRampCouchSolid } from '@/lib/fa'

const ALERT_TYPES: Array<SingleAlertType> = [
  SingleAlertType.UserAlert,
  SingleAlertType.DriverCardReadingAlert,
  SingleAlertType.DriverCardExpireAlert,
  SingleAlertType.VehicleCardReadingAlert,
  SingleAlertType.VehicleCalibrationAlert,
  SingleAlertType.VehicleCheckupDateAlert,
  SingleAlertType.VehicleInsuranceValidityDateAlert,
  SingleAlertType.FranceDeclarationAlert,
  SingleAlertType.GermanyDeclarationAlert,
  SingleAlertType.AustriaDeclarationAlert,
  SingleAlertType.HollandDeclarationAlert,
  SingleAlertType.DrivingLicenceValidToAlert,
]

const AlertType = () => {
  const { t } = useLocalize()
  const { type, setType } = useAlertForm()
  const alertTypeOptions: Option[] = ALERT_TYPES.map((at) => ({
    key: at.toString(),
    label: getSingleAlertName(at, t),
    value: at.toString(),
  }))

  return (
    <div className="tw-flex tw-gap-2">
      <div className="tw-jusit tw-flex tw-max-w-[200px] tw-flex-1 tw-items-start tw-gap-2 tw-font-medium tw-text-content-base">
        <FaIcon icon={faTruckRampCouchSolid} className="tw-max-w-[12px]" />
        <p className="tw-text-sm tw-font-semibold tw-text-content-base">
          {t('addAlertPopup.alert-type')}
        </p>
      </div>

      <div className="tw-flex tw-flex-1 tw-flex-col tw-gap-4">
        <FieldsetSelect
          value={type.toString()}
          options={alertTypeOptions}
          handleChange={(value) => setType(Number(value))}
          name="alertType"
        />
      </div>
    </div>
  )
}

export default AlertType
